export const CLOSE_PROFFIT_SEARCH_HEADER_SHARE_MODAL = 'CLOSE_PROFFIT_SEARCH_HEADER_SHARE_MODAL';
/**
 * 共有状況のモーダル表示フラグをOFFにする
 * @returns {{type: string}}
 */
export const closeProffitSearchHeaderShareModal = () => ({
    type: CLOSE_PROFFIT_SEARCH_HEADER_SHARE_MODAL,
});
